import React from 'react';
import View from './View';
import { getTotalConsumersRewardedByFacilityId } from '../../context/mockData/data';
var RewardsCounterContainer = function (_a) {
    var fullWidth = _a.fullWidth;
    return (React.createElement(View, { fullWidth: !!fullWidth, isLoading: false, data: getTotalConsumersRewardedByFacilityId }));
};
export default RewardsCounterContainer;
